import { ref } from "vue";
import { COUNTRIES } from "@/helpers/countries";

interface useStateType {
  selectedStates: { name?: string; value?: string };
  getStateList: (country: string) => void;
}

interface IState {
  name: string;
  code: string;
  minZip: number;
  maxZip: number;
}

export function useState(): useStateType {
  const selectedStates = ref();
  let stateList: IState[] = [];

  const getStateList = (country) => {
    stateList = COUNTRIES[country]?.states;
    if (stateList.length > 0) {
      stateList = stateList.sort((s1: IState, s2: IState): number => {
        return s1.name > s2.name ? 1 : s1.name < s2.name ? -1 : 0;
      });
    }

    selectedStates.value = stateList.map((state) => {
      return {
        name: state.name,
        code: state.code,
      };
    });
  };

  return {
    selectedStates,
    getStateList,
  };
}
